module.exports = __webpack_public_path__ + "static/media/QualtricsXM_Step1_Image11.2e6ea02c.jpg";